import React, { useState } from 'react';
import { NavLink, Outlet, Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { contactLinks } from '../data';

const Layout = ({ navLinks }) => {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  const linkClasses = ({ isActive }) =>
    `text-sm font-medium transition-colors ${
      isActive ? 'text-white' : 'text-slate-400 hover:text-white'
    }`;

  const toggleMobileNav = () => setIsMobileNavOpen((prev) => !prev);
  const closeMobileNav = () => setIsMobileNavOpen(false);

  return (
    <>
      <header className="sticky top-0 z-30 border-b border-white/10 bg-background/80 backdrop-blur">
        <div className="mx-auto flex w-full max-w-6xl items-center gap-4 px-4 py-4">
          <Link
            className="text-base font-semibold tracking-[0.2em] uppercase"
            to="/"
            onClick={closeMobileNav}
          >
            Andrew Barber
          </Link>
          <nav className="hidden flex-1 items-center gap-4 text-sm md:flex">
            {navLinks.map((link) => (
              <NavLink key={link.to} to={link.to} end={link.to === '/'} className={linkClasses}>
                {link.label}
              </NavLink>
            ))}
          </nav>
          <a
            className="hidden items-center rounded-full border border-white/20 px-4 py-2 text-sm font-semibold text-white transition hover:border-brand hover:text-white md:inline-flex"
            href="https://docs.google.com/document/d/11Av90GSfSIhnjiVHbFpdwCQtaNClwCZxsAUkQS6PUtU/edit?usp=sharing"
            target="_blank"
            rel="noreferrer"
          >
            View Résumé
          </a>
          <button
            className="ml-auto inline-flex items-center justify-center rounded-full border border-white/20 p-2 text-white transition hover:border-white md:hidden"
            type="button"
            onClick={toggleMobileNav}
            aria-expanded={isMobileNavOpen}
            aria-controls="mobile-nav"
            aria-label="Toggle navigation menu"
          >
            {isMobileNavOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
        <div
          className={`md:hidden transition-all duration-200 ease-out ${
            isMobileNavOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
          }`}
        >
          <div
            id="mobile-nav"
            className="mx-4 mb-4 flex flex-col gap-3 rounded-2xl border border-white/10 bg-black/70 px-4 py-4 text-sm shadow-xl backdrop-blur"
          >
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === '/'}
                onClick={closeMobileNav}
                className={({ isActive }) => `${linkClasses({ isActive })} py-1`}
              >
                {link.label}
              </NavLink>
            ))}
            <a
              className="inline-flex items-center justify-center rounded-full border border-white/20 px-4 py-2 text-sm font-semibold text-white transition hover:border-brand hover:text-white"
              href="https://docs.google.com/document/d/11Av90GSfSIhnjiVHbFpdwCQtaNClwCZxsAUkQS6PUtU/edit?usp=sharing"
              target="_blank"
              rel="noreferrer"
              onClick={closeMobileNav}
            >
              View Résumé
            </a>
          </div>
        </div>
      </header>

      <main className="relative z-10">
        <Outlet />
      </main>

      <footer className="border-t border-white/10 bg-black/30 py-12">
        <div className="mx-auto grid w-full max-w-6xl gap-8 px-4 text-sm text-slate-300 md:grid-cols-4">
          <div>
            <h3 className="text-lg font-semibold text-white">Andrew Barber</h3>
            <p>Learning to create impact through AI, data, and playful interfaces.</p>
          </div>
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-widest text-white">Quick Links</h4>
            <div className="mt-3 flex flex-col gap-2">
              {navLinks.map((link) => (
                <NavLink key={link.to} to={link.to} end={link.to === '/'} className={linkClasses}>
                  {link.label}
                </NavLink>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-widest text-white">Connect</h4>
            <div className="mt-3 flex flex-col gap-2">
              <a href={contactLinks.find(link => link.label === 'Email').href} className="hover:text-white">Email</a>
              <a href={contactLinks.find(link => link.label === 'GitHub').href} target="_blank" rel="noreferrer" className="hover:text-white">
                GitHub
              </a>
              <a
                href={contactLinks.find(link => link.label === 'LinkedIn').href}
                target="_blank"
                rel="noreferrer"
                className="hover:text-white"
              >
                LinkedIn
              </a>
            </div>
          </div>
          <div>
            <p>“I can do all things through Christ who strengthens me.” <br /><br /> Philippians 4:13</p>
          </div>
        </div>
        <p className="mt-10 text-center text-xs text-slate-500">
          © {new Date().getFullYear()} Andrew Barber. All rights reserved.
        </p>
      </footer>
    </>
  );
};

export default Layout;
